import { Popover } from "antd";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import flagUK from "../../../../../asset/flag-uk.png";
import flagVN from "../../../../../asset/flag-vn.png";
import Item from "./components/Item";
import styles from "./styles.module.css";
import { useLocation, useNavigate } from "react-router-dom";

const LanguageSelect = ({ className = "" }) => {
  const { i18n } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const [openPopover, setOpenPopover] = useState(false);

  const languages = {
    en: {
      key: "en",
      name: "English",
      flag: flagUK,
    },
    vi: {
      key: "vi",
      name: "Việt Nam",
      flag: flagVN,
    },
  };

  const handleChangeLanguage = (value) => {
    i18n.changeLanguage(value);

    let newPath = location.pathname;

    switch (value) {
      case "en":
        {
          if (location.pathname.includes("dang-ky"))
            newPath = "/nomination/sign-up";
          else if (location.pathname.includes("dang-nhap"))
            newPath = "/nomination/login";
          else if (location.pathname.includes("ho-so"))
            newPath = "/nomination/profile";
          else if (location.pathname.includes("ban-thu-ky"))
            newPath = "/nomination/secretariat";
          else if (location.pathname.includes("dong-de-cu"))
            newPath = "/nomination/close-nomination";
          else if (location.pathname.includes("quan-ly-email"))
            newPath = "/nomination/email-management";
          else if (location.pathname.includes("xac-thuc-mat-khau"))
            newPath = "/nomination/email-confirmation";
          else if (location.pathname.includes("doi-mat-khau"))
            newPath = "/nomination/change-password";
          else if (location.pathname.includes("quen-mat-khau"))
            newPath = "/nomination/forgot-password";
          else if (location.pathname.includes("dat-lai-mat-khau"))
            newPath = "/nomination/reset-password";
        }
        break;
      default:
        {
          if (location.pathname.includes("sign-up"))
            newPath = "/nomination/dang-ky";
          else if (location.pathname.includes("login"))
            newPath = "/nomination/dang-nhap";
          else if (location.pathname.includes("profile"))
            newPath = "/nomination/ho-so";
          else if (location.pathname.includes("secretariat"))
            newPath = "/nomination/ban-thu-ky";
          else if (location.pathname.includes("close-nomination"))
            newPath = "/nomination/dong-de-cu";
          else if (location.pathname.includes("email-management"))
            newPath = "/nomination/quan-ly-email";
          else if (location.pathname.includes("email-confirmation"))
            newPath = "/nomination/xac-thuc-mat-khau";
          else if (location.pathname.includes("change-password"))
            newPath = "/nomination/doi-mat-khau";
          else if (location.pathname.includes("forgot-password"))
            newPath = "/nomination/quen-mat-khau";
          else if (location.pathname.includes("reset-password"))
            newPath = "/nomination/dat-lai-mat-khau";
        }
        break;
    }

    navigate(newPath);

    handleOpenChange(false);
  };

  const handleOpenChange = (value) => {
    setOpenPopover(value);
  };

  const getFlag = (key) => {
    switch (key) {
      case languages.vi.key:
        return flagVN;
      case languages.en.key:
        return flagUK;
      default:
        return flagVN;
    }
  };

  const getCountryName = (key) => {
    switch (key) {
      case languages.vi.key:
        return "Tiếng Việt";
      case languages.en.key:
        return "English";
      default:
        return "Tiếng Việt";
    }
  };

  const content = (
    <div>
      {Object?.keys(languages).map((key, index) => {
        const language = languages[key];
        return (
          <Item
            key={language.key}
            flag={getFlag(language.key)}
            name={getCountryName(language.key)}
            onClick={() => handleChangeLanguage(language.key)}
            className={index !== 0 && styles.mTop4}
          />
        );
      })}
    </div>
  );

  return (
    <Popover
      placement="bottom"
      content={content}
      open={openPopover}
      onOpenChange={handleOpenChange}
      trigger="click"
    >
      <Item
        flag={getFlag(i18n.language)}
        name={getCountryName(i18n.language)}
        className={className}
      />
    </Popover>
  );
};

export default LanguageSelect;
